import React from 'react';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import styles from './PreferenceLabel.module.scss';

export function PreferenceLabel({ primary, secondary, icon, onClick }) {
  return (
    <div className={styles.PreferenceLabel}>
      <div className={styles.PreferenceLabel__left}>
        <div className={styles.PreferenceLabel__left__Primary}>{primary}</div>
        {secondary && <div className={styles.PreferenceLabel__left__Secondary}>{secondary}</div>}
      </div>
      {icon && <CreateOutlinedIcon onClick={onClick} className={styles.editIcon} />}
    </div>
  );
}
